<template>
  <div class="max-w-md mx-auto bg-white rounded-lg shadow-lg overflow-hidden">
    <div class="px-6 py-8">
      <h2 class="text-2xl font-bold text-center mb-8">用户注册</h2>
      
      <!-- 注册表单 -->
      <form @submit.prevent="handleRegister">
        <div class="mb-4">
          <label class="block text-sm font-medium mb-2" for="phone">手机号码</label>
          <div class="flex">
            <input v-model="form.phone" 
                   type="tel" 
                   id="phone" 
                   class="flex-1 px-4 py-2 border border-neutral-300 rounded-l-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                   placeholder="请输入手机号码">
            <button type="button" 
                    class="bg-primary/10 hover:bg-primary/20 text-primary px-4 py-2 border border-neutral-300 border-l-0 rounded-r-lg transition-colors"
                    @click="sendCode"
                    :disabled="!canSendCode || codeSending">
              {{ codeSending ? `${countdown}秒后重新发送` : '获取验证码' }}
            </button>
          </div>
          <span v-if="errors.phone" class="text-danger text-sm mt-1 block">{{ errors.phone }}</span>
        </div>
        
        <div class="mb-4">
          <label class="block text-sm font-medium mb-2" for="code">验证码</label>
          <input v-model="form.code" 
                 type="text" 
                 id="code" 
                 class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                 placeholder="请输入6位验证码">
          <span v-if="errors.code" class="text-danger text-sm mt-1 block">{{ errors.code }}</span>
        </div>
        
        <div class="mb-4">
          <label class="block text-sm font-medium mb-2" for="password">设置密码</label>
          <input v-model="form.password" 
                 type="password" 
                 id="password" 
                 class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                 placeholder="请设置6-20位密码（字母+数字）">
          <span v-if="errors.password" class="text-danger text-sm mt-1 block">{{ errors.password }}</span>
        </div>
        
        <div class="mb-6">
          <label class="block text-sm font-medium mb-2" for="confirmPassword">确认密码</label>
          <input v-model="form.confirmPassword" 
                 type="password" 
                 id="confirmPassword" 
                 class="w-full px-4 py-2 border border-neutral-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
                 placeholder="请再次输入密码">
          <span v-if="errors.confirmPassword" class="text-danger text-sm mt-1 block">{{ errors.confirmPassword }}</span>
        </div>
        
        <div class="mb-6">
          <label class="flex items-start cursor-pointer">
            <input type="checkbox" v-model="form.agreement" class="mt-1 mr-2">
            <span class="text-sm text-neutral-600">
              我已阅读并同意
              <router-link to="/terms-of-service" class="text-primary hover:underline">《用户条款》</router-link>
              和
              <router-link to="/privacy-policy" class="text-primary hover:underline">《隐私政策》</router-link>
            </span>
          </label>
          <span v-if="errors.agreement" class="text-danger text-sm mt-1 block">{{ errors.agreement }}</span>
        </div>
        
        <button type="submit" 
                class="w-full bg-primary hover:bg-primary/90 text-white font-medium py-2 px-4 rounded-lg transition-colors"
                :disabled="loading">
          <i v-if="loading" class="fa fa-spinner fa-spin mr-2"></i>
          注册
        </button>
      </form>
      
      <!-- 登录链接 -->
      <div class="mt-8 text-center">
        <span class="text-neutral-500">已有账号？</span>
        <router-link to="/login" class="text-primary font-medium hover:underline ml-1">立即登录</router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Register',
  data() {
    return {
      form: {
        phone: '',
        code: '',
        password: '',
        confirmPassword: '',
        agreement: false
      },
      errors: {},
      loading: false,
      codeSending: false,
      countdown: 60,
      timer: null
    }
  },
  computed: {
    canSendCode() {
      return /^1[3-9]\d{9}$/.test(this.form.phone)
    }
  },
  methods: {
    validateForm() {
      this.errors = {}
      
      // 验证手机号
      if (!this.form.phone) {
        this.errors.phone = '请输入手机号码'
      } else if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        this.errors.phone = '请输入有效的手机号码'
      }
      
      // 验证验证码
      if (!this.form.code) {
        this.errors.code = '请输入验证码'
      } else if (this.form.code.length !== 6) {
        this.errors.code = '验证码必须为6位数字'
      }
      
      // 验证密码
      if (!this.form.password) {
        this.errors.password = '请设置密码'
      } else if (!/^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d]{6,20}$/.test(this.form.password)) {
        this.errors.password = '密码必须包含字母和数字，长度6-20位'
      }
      
      // 验证确认密码
      if (!this.form.confirmPassword) {
        this.errors.confirmPassword = '请确认密码'
      } else if (this.form.confirmPassword !== this.form.password) {
        this.errors.confirmPassword = '两次输入的密码不一致'
      }
      
      // 验证协议
      if (!this.form.agreement) {
        this.errors.agreement = '请阅读并同意用户条款和隐私政策'
      }
      
      return Object.keys(this.errors).length === 0
    },
    sendCode() {
      if (!this.canSendCode) return
      
      this.codeSending = true
      
      // 模拟发送验证码
      setTimeout(() => {
        this.$bus.$emit('showMessage', '验证码已发送，请注意查收')
        
        // 开始倒计时
        this.timer = setInterval(() => {
          this.countdown--
          if (this.countdown <= 0) {
            clearInterval(this.timer)
            this.codeSending = false
            this.countdown = 60
            this.timer = null
          }
        }, 1000)
      }, 1000)
    },
    handleRegister() {
      if (!this.validateForm()) return
      
      this.loading = true
      
      // 模拟注册请求
      setTimeout(() => {
        this.loading = false
        this.$bus.$emit('showMessage', '注册成功！即将跳转到登录页面...')
        
        // 跳转到登录页
        setTimeout(() => {
          this.$router.push('/login')
        }, 1500)
      }, 2000)
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }
}
</script>